/**
 * Created by Administrador on 10/28/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('categoryService', categoryService);

    categoryService.$inject = ['$http', 'CONFIG', 'messageService'];

    function categoryService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/categories';
        var service = {
            getCategories: getCategories,
            getClassesByCategory: getClassesByCategory
        }

        return service;

        function getCategories(){
            return $http.get(urlBase)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getClassesByCategory(categoryId){
            return $http.get(urlBase + "/" + categoryId + "/classes")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }
    };

})();
